import React, { useCallback, useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNavigation } from '../../../common/navigation';
import { useCookies } from '../../../common/hooks/useCookies';
import { ExamSearch } from '../../components/Exam/ExamSearch';
import FormRow from '../../../app/components/FormRow';
import HealthcareFacilitySelector from '../../components/Selects/HealthcareFacilitySelector';

export const ExamsInFacilityView: React.FC = () => {
  const spd = useSpdCore();
  const nav = useNavigation();
  const cookies = useCookies();

  const [healthcareFacilityId, setHealthcareFacilityId] = useState<
    string | undefined
  >(cookies.healthcareFacilitySelector);

  const handleClick = async (id: string) => {
    void nav.examTests(id);
  };

  const getData = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.exams.getInFacilityWithoutJudgmentByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        healthcareFacilityId,
      ),
    [spd.exams, healthcareFacilityId],
  );

  const getCount = useCallback(
    (filterText?: string, filterColumns?: string) =>
      spd.exams.getInFacilityWithoutJudgmentCount(
        filterText,
        filterColumns,
        healthcareFacilityId,
      ),
    [spd.exams, healthcareFacilityId],
  );

  return (
    <Card>
      <Card.Body>
        <Card.Title className="pb-3">Badania w placówce</Card.Title>
        <Form className="mb-4">
          <Row>
            <Col md={5}>
              <FormRow controlId="healthcareFacility" label="Placówka">
                <HealthcareFacilitySelector
                  value={healthcareFacilityId || ''}
                  onChange={e => {
                    setHealthcareFacilityId(e.value);
                    if (e.value) {
                      cookies.setHealthcareFacilitySelector(e.value);
                    }
                  }}
                  placeholder="Wybierz placówkę"
                  addAll={false}
                  clearable={true}
                />
              </FormRow>
            </Col>
          </Row>
        </Form>
        <ExamSearch
          getData={getData}
          getCount={getCount}
          onRowClick={handleClick}
          initialOrderColumn="exams.startDate"
          initialOrderDirection="ASC"
          withFilterInColumns={true}
        />
      </Card.Body>
    </Card>
  );
};
